import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navbar from '../../components/Navbar';
import SidebarSeccion from '../../components/SidebarSeccion';
import { useAuth, API_URL } from '../../context/AuthContext';
import { getTema } from '../../theme';
import { PencilSquareIcon, TrashIcon, LinkIcon } from '@heroicons/react/24/outline';

export default function ClasesOnline({ tipo, nivel }) {
  const { usuario } = useAuth();
  const tema = getTema(tipo);
  const esProfesor = ['profesor','admin'].includes(usuario?.rol);
  const [clases, setClases] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [mostrarForm, setMostrarForm] = useState(false);
  const [editando, setEditando] = useState(null);
  const [form, setForm] = useState({ titulo: '', link: '', fecha: '', hora: '', notas: '' });

  const cargar = async () => {
    try {
      setCargando(true);
      const res = await axios.get(`${API_URL}/clases-online?tipo=${tipo}&nivel=${nivel}`);
      setClases(res.data);
    } catch {} finally { setCargando(false); }
  };

  useEffect(() => { cargar(); }, [tipo, nivel]);

  const handleGuardar = async (e) => {
    e.preventDefault();
    try {
      if (editando) {
        await axios.put(`${API_URL}/clases-online/${editando}`, { ...form, activa: 1 });
      } else {
        await axios.post(`${API_URL}/clases-online`, { ...form, tipo, nivel });
      }
      setForm({ titulo: '', link: '', fecha: '', hora: '', notas: '' });
      setMostrarForm(false);
      setEditando(null);
      cargar();
    } catch (e) { alert(e.response?.data?.error || 'Error'); }
  };

  const iniciarEdicion = (c) => {
    setForm({ titulo: c.titulo, link: c.link, fecha: c.fecha || '', hora: c.hora || '', notas: c.notas || '' });
    setEditando(c.id);
    setMostrarForm(true);
  };

  const eliminar = async (id) => {
    if (!window.confirm('¿Eliminar esta clase?')) return;
    await axios.delete(`${API_URL}/clases-online/${id}`);
    cargar();
  };

  const inputStyle = { width: '100%', padding: '10px 14px', borderRadius: '8px', background: tema.bg, border: `1px solid ${tema.border}`, color: tema.text, fontSize: '14px' };

  const clasesActivas = clases.filter(c => c.activa);
  const clasesAntiguas = clases.filter(c => !c.activa);

  return (
    <div style={{ minHeight: '100vh', background: tema.bg }}>
      <Navbar tema={tema} titulo={tipo === 'militar' ? 'Programa Militar' : 'Inglés Civil'} tipo={tipo} nivel={nivel} />
      <div className="page-layout">
        <SidebarSeccion tema={tema} tipo={tipo} nivel={nivel} />
        <main className="page-content">
          <div className="fade-in">
            <div className="section-header" style={{ marginBottom: '28px' }}>
              <div>
                <h2 style={{ color: tema.text, fontSize: '26px', marginBottom: '4px' }}>🎥 Clases Online</h2>
                <p style={{ color: tema.muted, fontSize: '14px' }}>Accede a las sesiones en directo para {nivel}</p>
              </div>
              {esProfesor && (
                <button onClick={() => { setMostrarForm(!mostrarForm); setEditando(null); setForm({ titulo: '', link: '', fecha: '', hora: '', notas: '' }); }}
                  style={{ background: tema.primary, border: 'none', color: '#fff', padding: '10px 20px', borderRadius: '50px', fontSize: '14px', fontWeight: 600, cursor: 'pointer', boxShadow: '0 4px 14px rgba(139,111,212,0.4)' }}>
                  {mostrarForm && !editando ? '✕ Cancelar' : '+ Nueva clase'}
                </button>
              )}
            </div>

            {esProfesor && mostrarForm && (
              <form onSubmit={handleGuardar} style={{ background: tema.bgCard, border: `1px solid ${tema.border}`, borderRadius: '12px', padding: '24px', marginBottom: '28px' }}>
                <h3 style={{ color: tema.accent, marginBottom: '16px', fontSize: '16px', fontFamily: 'Inter, sans-serif' }}>
                  {editando ? 'Editar clase' : 'Nueva clase online'}
                </h3>
                <div style={{ marginBottom: '14px' }}>
                  <label style={{ color: tema.muted, fontSize: '12px', display: 'block', marginBottom: '5px' }}>Título *</label>
                  <input style={inputStyle} value={form.titulo} onChange={e => setForm({ ...form, titulo: e.target.value })} required placeholder="Ej: Clase semana 12" />
                </div>
                <div className="form-grid-2">
                  <div>
                    <label style={{ color: tema.muted, fontSize: '12px', display: 'block', marginBottom: '5px' }}>Fecha</label>
                    <input type="date" style={inputStyle} value={form.fecha} onChange={e => setForm({ ...form, fecha: e.target.value })} />
                  </div>
                  <div>
                    <label style={{ color: tema.muted, fontSize: '12px', display: 'block', marginBottom: '5px' }}>Hora</label>
                    <input type="time" style={inputStyle} value={form.hora} onChange={e => setForm({ ...form, hora: e.target.value })} />
                  </div>
                </div>
                <div style={{ marginBottom: '14px' }}>
                  <label style={{ color: tema.muted, fontSize: '12px', display: 'block', marginBottom: '5px' }}>Enlace de la clase *</label>
                  <input style={inputStyle} value={form.link} onChange={e => setForm({ ...form, link: e.target.value })} required placeholder="https://meet.google.com/..." />
                </div>
                <div style={{ marginBottom: '20px' }}>
                  <label style={{ color: tema.muted, fontSize: '12px', display: 'block', marginBottom: '5px' }}>Notas (opcional)</label>
                  <input style={inputStyle} value={form.notas} onChange={e => setForm({ ...form, notas: e.target.value })} placeholder="Contraseña, instrucciones..." />
                </div>
                <button type="submit" style={{ background: tema.primary, border: 'none', color: '#fff', padding: '10px 24px', borderRadius: '50px', fontSize: '14px', fontWeight: 600, cursor: 'pointer', boxShadow: '0 4px 14px rgba(139,111,212,0.4)' }}>
                  {editando ? 'Guardar cambios' : 'Crear clase'}
                </button>
              </form>
            )}

            {cargando ? (
              <div style={{ color: tema.muted, padding: '48px', textAlign: 'center' }}>Cargando...</div>
            ) : clases.length === 0 ? (
              <div style={{ color: tema.muted, textAlign: 'center', padding: '64px', background: tema.bgCard, borderRadius: '12px' }}>
                <div style={{ fontSize: '48px', marginBottom: '12px' }}>🎥</div>
                <p>No hay clases online programadas</p>
              </div>
            ) : (
              <>
                {clasesActivas.map(c => (
                  <div key={c.id} style={{
                    background: `linear-gradient(135deg, ${tema.bgCard} 0%, ${tema.bgHover} 100%)`,
                    border: `2px solid ${tema.accent}44`,
                    borderRadius: '14px', padding: '24px', marginBottom: '14px',
                  }}>
                    <div className="card-row" style={{ alignItems: 'flex-start' }}>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '6px' }}>
                          <span style={{ background: `${tema.success}22`, color: tema.success, borderRadius: '20px', padding: '2px 12px', fontSize: '11px', fontWeight: 700 }}>● EN DIRECTO</span>
                          <span style={{ color: tema.muted, fontSize: '12px' }}>Google Meet</span>
                        </div>
                        <h3 style={{ color: tema.text, fontSize: '18px', marginBottom: '6px', fontFamily: 'Inter, sans-serif' }}>{c.titulo}</h3>
                        {(c.fecha || c.hora) && (
                          <p style={{ color: tema.muted, fontSize: '13px', marginBottom: '6px' }}>
                            📅 {c.fecha && new Date(c.fecha).toLocaleDateString('es-ES')} {c.hora && `· 🕐 ${c.hora}`}
                          </p>
                        )}
                        {c.notas && <p style={{ color: tema.muted, fontSize: '13px' }}>📝 {c.notas}</p>}
                      </div>
                      <div className="card-actions">
                        <a href={c.link} target="_blank" rel="noreferrer"
                          style={{ background: tema.success, border: 'none', color: '#fff', padding: '10px 20px', borderRadius: '8px', fontSize: '14px', fontWeight: 700, display: 'flex', alignItems: 'center', gap: '6px' }}>
                          <LinkIcon style={{ width: 16, height: 16 }} /> Unirse
                        </a>
                        {esProfesor && (
                          <>
                            <button onClick={() => iniciarEdicion(c)}
                              style={{ background: `${tema.accent}22`, border: `1px solid ${tema.accent}44`, color: tema.accent, padding: '10px 14px', borderRadius: '8px', fontSize: '13px', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                              <PencilSquareIcon style={{ width: 17, height: 17 }} />
                            </button>
                            <button onClick={() => eliminar(c.id)}
                              style={{ background: 'rgba(231,76,60,0.1)', border: '1px solid rgba(231,76,60,0.2)', color: '#e74c3c', padding: '10px 12px', borderRadius: '8px', fontSize: '13px', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                              <TrashIcon style={{ width: 17, height: 17 }} />
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                ))}

                {clasesAntiguas.map(c => (
                  <div key={c.id} style={{ background: tema.bgCard, border: `1px solid ${tema.border}`, borderRadius: '12px', padding: '18px 24px', marginBottom: '10px', opacity: 0.6 }}><div className="card-row">
                    <div>
                      <p style={{ color: tema.text, fontFamily: 'Inter, sans-serif' }}>{c.titulo}</p>
                      <p style={{ color: tema.muted, fontSize: '12px' }}>Google Meet · {c.fecha && new Date(c.fecha).toLocaleDateString('es-ES')}</p>
                    </div>
                    {esProfesor && (
                      <button onClick={() => eliminar(c.id)}
                        style={{ background: 'none', border: 'none', color: '#e74c3c', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                        <TrashIcon style={{ width: 16, height: 16 }} />
                      </button>
                    )}
                  </div></div>
                ))}
              </>
            )}
          </div>
        </main>
      </div>
    </div>
  );
}
